<template>
  <div class="modal-custom-k">
    <div class="modal-content-custom">
      <div class="modal-box-custom" :style="`width:${width};`">
        <div class="modal-header-custom">
          <h1 class="modal-header-text">
            {{ title }}
          </h1>

          <feather
            type="x"
            size="20px"
            class="modal-icon-custom"
            @click="$emit('closemodal')"
          />
        </div>

        <div class="modal-container-custom">
          <slot name="modalcontent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
	props: {
		title: {
			type: String,
			default: 'Modal',
		},
		width: {
			type: String,
			default: '400px;',
		},
	},
	data() {
		return {
			id: this.$store.getters.getmodaldata.id,
			descricao: this.$store.getters.getmodaldata.descricao,
			associado_id: this.$store.getters.getmodaldata.associado_id,
			integracao_id: this.$store.getters.getmodaldata.integracao_id,
			tipo: this.$store.getters.getmodaldata.tipo,
			status: this.$store.getters.getmodaldata.status,
			name: '',
			checkboxGroup: '',
			additional_grouped: [],

		};
	},

	methods: {
		uniqueCheck(e) {
			this.additional_grouped = [];

			if (e.target.checked) {
				this.additional_grouped.push(e.target.value);
			}
		},
	},

};

</script>

<style scoped>

.modal-container-custom {
    padding: 20px;
}

.modal-icon-custom {
  cursor: pointer;
}
.modal-custom-k {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.137);
  display: table;
  transition: all 0.5s ease;
  overflow-y: scroll;
  align-items: flex-end;
}

.button-container {
  display: flex;
  width: 100%;
}

.modal-content-custom {
  display: flex;
   z-index: 99;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;

}

.modal-box-custom {
  transition: all 0.5s ease;
  height: 100%;
  z-index: 99;
  background-color: #FFF;

}

.modal-header-custom {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(223, 223, 223, 0.342);

}

.modal-header-text {
  font-size: 20px;
}

</style>
